import React from 'react';
import { Show, SimpleShowLayout, TextField, ReferenceField } from 'react-admin';

const PrestacionGrupoValidacionesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <ReferenceField
        source="idGrupoValidaciones"
        reference="grupo-validaciones"
        label="Grupo Validaciones"
      >
        <TextField source="descripcion" />
      </ReferenceField>
      <ReferenceField
        source="idPrestacion"
        reference="prestaciones"
        label="Prestacion"
      >
        <TextField source="descripcion" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
);

export default PrestacionGrupoValidacionesShow;
